(function($){

    /**
     * initializeBlock
     *
     * Adds custom JavaScript to the block HTML.
     *
     * @date    15/4/19
     * @since   1.0.0
     *
     * @param   object $block The block jQuery element.
     * @param   object attributes The block attributes (only available when editing).
     * @return  void
     */
    var initializeBlock = function( $block ) {
        $block.find("ul.blocks-gallery-grid").slick({
					useTransform: true,
					asNavFor: ".is-slider-nav ul.blocks-gallery-grid",
					cssEase: "ease-out",
					dots: false,
					prevArrow: false,
					nextArrow: false,
					infinite: false,
					speed: 500,
					slidesToShow: 1,
					slidesToScroll: 1,
					autoplay: true,
					autoplaySpeed: 3750,
					// swipeToSlide: true,
					adaptiveHeight: true,
					// focusOnSelect: true,
				});     
    }
    var initializeBlockNav = function ($block, $num) {
            $block.find('li a').attr('href','#').on('click',function(e){ e.preventDefault(); });
			$block.find("ul.blocks-gallery-grid").slick({
				useTransform: true,
				asNavFor: ".is-slider ul.blocks-gallery-grid",
				cssEase: "ease-out",
				infinite: false,
				// speed: 500,
				slidesToShow: 2 * $num,
				slidesToScroll: 2 * $num,
				focusOnSelect: true,
			});
		};

    // Initialize each block on page load (front end).
    $(document).ready(function(){
        var slider_gallery = $('.wp-block-gallery.is-slider');
        if (slider_gallery) {
            for(n=2; n<10; n++){
                if (slider_gallery.is(".columns-" + n)) {
                    // console.log( "I am n: " + n);
                    var nicki = slider_gallery
                                .clone()
                                .insertAfter(slider_gallery)
                                .addClass("is-slider-nav")
                                .removeClass("is-slider")
                                .removeClass("is-lightbox");
                    initializeBlockNav( nicki, n);
                }
            }
        }
        $('.wp-block-gallery.is-slider').each(function(){
            initializeBlock( $(this) );
        });

        // Lightbox
        var lightbox_gallery = $('.wp-block-gallery.is-lightbox');
        if (lightbox_gallery) {
            if (lightbox_gallery.not(".is-slider-nav")) {
                lightbox_gallery.find('a').simpleLightbox();
            }

        }
        
    });

    // Initialize dynamic block preview (editor).
    // if( window.acf ) {
    //     window.acf.addAction( 'render_block_preview/type=feature-slider', initializeBlock );
    // }

})(jQuery);